import { makeStyles } from 'tss-react/mui'
import { nunito_sans } from '@styles/fonts'

const useStyles = makeStyles()((theme) => ({
  root: {
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    height: 38,
    width: '100%',
    zIndex: 22222,
    display: 'flex',
    alignItems: 'center',
    background:
      'linear-gradient(90.02deg, #FDCEAD 11.54%, #E0ACD5 31.34%, #EAA539 85.24%, #E36C26 99.98%)',
    p: {
      fontFamily: nunito_sans.style.fontFamily,
      fontWeight: 700,
      fontSize: '14px',
      textAlign: 'center',
      width: '100%',
      textTransform: 'uppercase',
      color: '#FFFFFF',
    },
    a: {
      textTransform: 'uppercase',
      color: '#FFFFFF',
    },

    [theme.breakpoints.down('md')]: {
      p: {
        fontSize: '10px',
      },
      height: 27,
    },
  },
  zenMode: {
    background: 'black',
  },
}))

export default useStyles
